/**
 * Os convidados de uma sala, sempre como LISTA.
 *
 * `rooms.invited_users` é uma coluna JSON nullable, e ela NASCE NULA: o
 * `RoomService::store()` não a preenche. Ela só ganha valor quando alguém entra
 * na sala pela primeira vez -- ou seja, o caso nulo é exatamente o da primeira
 * vez, que é justamente quando este código roda.
 *
 * O código antigo fazia `JSON.parse(room.invited_users)` direto e chamava
 * `.includes()` no resultado. `JSON.parse(null)` devolve `null` -- porque
 * `String(null)` é o texto "null", que é JSON válido -- então o `.includes`
 * estourava com "Cannot read properties of null".
 *
 * O efeito era o botão "Entrar na Sala" simplesmente não funcionar, com o erro
 * morrendo no console. Encontrado em 10/09/2026 testando o WhatsApp, mas o bug
 * não é do WhatsApp: na base local, 15 salas tinham a coluna nula, incluindo
 * salas abertas do chat do site.
 */

/**
 * Quem manda aqui é o `Array.isArray`: é ele que garante que TODO caminho
 * devolva lista -- nulo, objeto, número, texto. Os outros dois guardas são
 * defesa em profundidade, e a mutação confirmou que nenhuma entrada os
 * distingue sozinhos.
 *
 * Ficaram assim mesmo por duas razões: o `?? '[]'` diz em voz alta que
 * "ausente significa lista vazia", e evita usar EXCEÇÃO como caminho normal --
 * sem ele, abrir qualquer sala nova lançaria um SyntaxError capturado, e quem
 * depurasse com "break on exceptions" pararia a cada clique.
 *
 * @param {{invited_users?: string|null}|null|undefined} room
 * @returns {Array} sempre um array, nunca null
 */
export const convidadosDaSala = (room) => {
    try {
        const lista = JSON.parse(room?.invited_users ?? '[]');

        return Array.isArray(lista) ? lista : [];
    } catch (e) {
        // JSON quebrado na coluna não pode impedir alguém de atender. Uma sala
        // com dado corrompido ainda precisa poder receber operador.
        return [];
    }
};
